/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const GlobeOneIcon = /*#__PURE__*/ createSvgIcon(
  'GlobeOneIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.53 18a.5.5 0 01.5-.5h5.89a.5.5 0 110 1H7.03a.5.5 0 01-.5-.5z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.5 18v-2.11h1V18h-1zM10 2.5a5.39 5.39 0 100 10.78A5.39 5.39 0 0010 2.5zM3.61 7.89a6.39 6.39 0 1112.78 0 6.39 6.39 0 01-12.78 0z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.55 2.053a.5.5 0 01.707.027A8.43 8.43 0 0118.5 7.89a8.5 8.5 0 01-13.95 6.585l-1.777 1.77a.5.5 0 11-.706-.71l2.11-2.1a.5.5 0 01.695-.01A7.5 7.5 0 0017.5 7.894v-.01a7.43 7.43 0 00-1.977-5.124.5.5 0 01.027-.707z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default GlobeOneIcon;
